class AssetStatus {
}

AssetStatus.statusVariants = {
  pending: 'secondary',
  approved: 'success',
  rejected: 'danger',
  changes_requested: 'warning',
  deactivated: 'danger',
  buyout: 'warning'
}

AssetStatus.statusIcons = {
  pending: 'far fa-clock',
  approved: 'fas fa-check',
  rejected: 'fas fa-info-circle',
  changes_requested: 'far fa-clock',
  deactivated: 'fas fa-ban',
  buyout: 'fas fa-triangle-exclamation'
}

export default AssetStatus;